<template>
  <div>
    <a href="javascript:void(0)" @click="openForm" title="Delete incentive registration"><i class="fa fa-times text-danger"></i> </a>
    <div class="modal fade" id="deleteIRModal" ref="deleteIRModal" tabindex="-1" role="dialog" aria-hidden="true" style="background: rgba(0,0,0,0.7);">
      <div class="modal-dialog modal-dialog-centered" style="width: 100%; max-width:780px; margin-top: 30px; margin-bottom: 30px;">
        <div class="modal-content">
          <div class="modal-header">
            <h3 style="color: #000; font-size: 22px; padding: 0; margin: 0; text-align: center;">Delete Registration</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body clearfix text-left" style="padding: 20px 30px 30px;">
            <p>Are you sure you want to delete this registration?</p>
            <form method="post" :action="`/incentive-registration/delete/${incentiveRegistrationId}`">
              <input type="hidden" name="_token" :value="token">
              <div class="form-group d-flex justify-content-end">
                <button data-dismiss="modal" aria-label="Close" class="close btn btn-light mr-3">Cancel</button>
                <button type="submit" class="btn btn-danger">Delete</button>
              </div>
            </form>
            <div v-if="success" class="alert alert-success mt-3" role="alert">
              <p class="mb-0">Email Updated</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IncentiveRegistrationService from '../services/incentive-registration.service';
import FormMixin from '../mixins/FormMixin';

export default {
  props: {
    incentiveRegistrationId: {
      type: String
    }
  },
  mixins: [
    FormMixin,
  ],
  data() {
    return {
      newEmail: '',
      token: document.head.querySelector("[name=csrf-token]").content
    }
  },
  methods: {
    openForm() {
      $(this.$refs.deleteIRModal).modal('show');
    },
    async submit() {
      this.success = false;
      this.pending = true;
      this.errorMessage = '';
      this.validationErrors = {};

      try {
        const response = await IncentiveRegistrationService.updateEmail(this.incentiveRegistrationId, { email: this.newEmail});
        this.success = true;

        setTimeout(() => {
          this.newEmail = '';
          this.success = false;
          $(this.$refs.deleteIRModal).modal('hide');
          window.location = response.redirect;
        }, 3000);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pending = false;
      }
    },
  }
}
</script>